import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-imagerie',
  imports: [RouterOutlet],
  templateUrl: './main-imagerie.component.html',
  styleUrl: './main-imagerie.component.scss'
})
export class MainImagerieComponent {}
